// Marketing content. Guest-facing answers stay guest-appropriate; operational
// detail lives in the "For Businesses" section only.

export const EXPERIENCES = {
  heading: "Two experiences. One connected operation.",
  business: {
    title: "For businesses",
    body: "Configure departments, services and staff; manage reservations, guest requirements, complaints and operational workflows.",
  },
  guest: {
    title: "For guests",
    body: "Access participating services, submit reservation requests, provide relevant requirements and stay informed when an issue is being resolved.",
  },
  tagline: "BeetDrop connects the information between both sides while keeping access appropriate to each user's role.",
};

export const HOSPITALITY_TYPES = [
  "Hotels", "Resorts", "Guest houses", "B&Bs", "Lodges", "Restaurants", "Cafés",
  "Pubs", "Event venues", "Multi-service properties", "Hospitality groups", "Multi-location operations",
];

export const FAQ_SECTIONS = [
  {
    title: "General",
    items: [
      {
        q: "What is BeetDrop?",
        a: "BeetDrop is a hospitality operations platform that centralises communication, visibility and accountability between reception, management and operational departments, so guest information and service issues reach the right people and are acknowledged, assigned, handled and resolved properly. It is not primarily a reservation system.",
      },
      {
        q: "Who is BeetDrop for?",
        a: "BeetDrop is for hospitality businesses — from a single site to multi-location operations — and the guests they serve. Businesses configure departments, services and staff and manage their operations; guests access participating services, submit reservation requests and stay informed when an issue is being handled.",
      },
    ],
  },
  {
    title: "For Businesses",
    items: [
      {
        q: "How does my business get started?",
        a: "You register your business, verify your email and accept the Terms & Conditions, then add your locations, departments, services and staff. Every new business starts with a 30-day free trial with full platform access, no setup fee and no long-term contract.",
      },
      {
        q: "Which departments can use BeetDrop?",
        a: "BeetDrop includes default departments — Reception, Food & Beverage, Kitchen, Housekeeping, Maintenance and Events — and lets you add your own custom or outsourced departments such as Security, Spa, Pool, Beach or Golf. The default departments are created automatically for each new location.",
      },
      {
        q: "Can we create our own services?",
        a: "Yes. Businesses create services and connect each one to the correct location and department, and set its capacity and availability.",
      },
      {
        q: "Can BeetDrop support more than one location?",
        a: "Yes. BeetDrop supports single or multi-location businesses, with complete data separation between businesses. Centralised multi-location management and reporting are available on the Signature plan.",
      },
      {
        q: "Who approves reservations?",
        a: "Guest reservation requests are approved by authorised Reception or GM/Ops users. Relevant departments can view bookings for their services but do not control approval.",
      },
      {
        q: "How do staff permissions work?",
        a: "Access is based on role and department. Staff and department managers access information relevant to their responsibilities, while authorised GM/Ops/Owner users have wider operational oversight.",
      },
      {
        q: "How are guest complaints handled?",
        a: "Reception receives and acknowledges the complaint, while the relevant department and authorised management are notified. Responsibility can then be assigned by authorised management and the issue tracked through to resolution, with the guest receiving the appropriate outcome update.",
      },
      {
        q: "How does BeetDrop pricing work?",
        a: "BeetDrop uses a predictable monthly subscription based on business size and operational complexity — not on the number of reservations, guests or complaints you handle. Plans are Launch (£39/month), Elevate (£89/month) and Signature (from £199/month), each also available annually with two months free. Every new business starts with a 30-day free trial.",
      },
    ],
  },
  {
    title: "For Guests",
    items: [
      {
        q: "How do I use BeetDrop as a guest?",
        a: "You create a guest account, choose a participating location and service, and submit reservation requests. You can also raise service issues and stay informed as they are handled.",
      },
      {
        q: "Can guests request reservations through BeetDrop?",
        a: "Guests can submit reservation requests for available services and provide relevant information such as party size, dietary requirements, allergies and optional notes. Reservation requests are then subject to approval by the business.",
      },
      {
        q: "Can guests provide dietary requirements, allergies and special requests?",
        a: "Yes. When submitting a reservation request, guests can provide party size, dietary requirements, allergies and optional notes. For food-related services this information is required, and it stays attached to the booking so the relevant teams can see and acknowledge it.",
      },
      {
        q: "What happens when a guest raises a complaint?",
        a: "Your request is received and acknowledged, and you can follow its status in your account. Once it has been handled you receive the appropriate outcome update, including any resolution note.",
      },
    ],
  },
];
